import Pusher from 'pusher-js';
// Enable pusher logging - don't include this in production
export const pusher = new Pusher('58b1a736b7d1c40a8af9', {
    cluster: 'ap1',
    // add any other configurations you need
});
